import React, { Fragment } from 'react';

import { Skeletons } from '../../lib-atomic';

const Loader = props => {
  return <Fragment>
    <Skeletons.Large />
    <Skeletons.Medium />
    <Skeletons.Large />
    <Skeletons.Medium />
    <Skeletons.Large />
    <Skeletons.Medium />
    <Skeletons.Large />
    <Skeletons.Medium />
  </Fragment>
}

export default Loader;
